import { axios } from 'lib/axios';

export const authenticatorLogin = (data) => {
  return axios.post('/user/authenticator/login', data);
};
